export function splitText(text: string) {
    if (!text) {
        return [];
    }

    const regex = new RegExp('(</?br>)|\\n|\\r', 'g');
    const split = text.split(regex);

    return split.filter(
        (part) => !!part && !part.match(new RegExp('(</?br>)', 'g')),
    );
}
